<div class="place-select">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="place-select__field">
    @if (label) {
      <mat-label>{{ label | translate }}</mat-label>
    }
    <input
      type="text"
      matInput
      autocomplete="off"
      [formControl]="inputControl"
      [matAutocomplete]="auto"
      [placeholder]="'TRANS__IMPORT__PLACE_SEARCH' | translate"
      (blur)="onBlur()"
    >
    @if (searching) {
      <mat-progress-spinner matSuffix mode="indeterminate" diameter="16"></mat-progress-spinner>
    }
    @if (pickedPath) {
      <mat-hint class="place-select__hint">↳ {{ pickedPath }}</mat-hint>
    }
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
      @for (option of options; track option.artifact_id) {
        <mat-option [value]="option" class="place-select__option">
          <span class="place-select__name">{{ option.name }}</span>
          @if (option.path) {
            <span class="place-select__path">↳ {{ option.path }}</span>
          }
        </mat-option>
      }
      @if (!searching && !options.length && inputControl.value) {
        <mat-option disabled>{{ 'TRANS__IMPORT__PLACE_NO_HITS' | translate }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <button
    mat-stroked-button
    type="button"
    class="place-select__browse"
    (click)="openTree()"
  >
    <mat-icon>account_tree</mat-icon>
    {{ 'TRANS__IMPORT__PLACE_BROWSE_TREE' | translate }}
  </button>
</div>
